import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { IResponse } from "@bt/shared";
import { map } from "rxjs/operators";

import { ApiService } from "./api.service";
import { NotificationModel} from '@bt/core/models';
import { PushNotifIdsModel} from '@bt/core/models';
import { PushNotifSortingModel } from '../models/pushNotifSortingModel';

@Injectable()
export class PushNotificationService {

  constructor(private api: ApiService) { }

  //получение кол- ва пользователей
  public getListNotifications(notificationSortingModel: PushNotifSortingModel): Promise<IResponse<NotificationModel[]>> {
    return this.api.post<NotificationModel[]>("api/pushnotification/getlist/", notificationSortingModel).toPromise();
  }

  public getNotification(notifId:string): Promise<IResponse<NotificationModel>> {
    return this.api.get<NotificationModel>("api/pushnotification/get?notifId="+notifId).toPromise();
  }

  public createOrEditNotification(notificationModel: NotificationModel): Promise<IResponse<boolean>> {
    return this.api.post<boolean>("api/pushnotification/createoredit", notificationModel).toPromise();
  }

  public deletePushNotification(pushNotificationToDelete: PushNotifIdsModel):Promise<IResponse<boolean>> {
    return this.api.put<boolean>("api/pushnotification/deletepushnotification", pushNotificationToDelete).toPromise();
  }
  public startOrStopNotification(startStopNotifId: number): Promise<IResponse<boolean>> {
    return this.api.get<boolean>("api/pushnotification/startorstopnotif/"+ startStopNotifId).toPromise();
  }
  public duplicatePushNotification(pushNotificationToDuplicate: PushNotifIdsModel): Promise<IResponse<boolean>> {
    return this.api.put<boolean>("api/pushnotification/duplicate", pushNotificationToDuplicate).toPromise();
  }
}





// WEBPACK FOOTER //
// ./src/app/core/services/push-notification.service.ts